import * as React from "react";
import CategoryPanel from "../commons/components/CategoryPanel";
import AnalysedCriterion from "../commons/model/treatment/AnalysedCriterion";

interface IssueToTreatProps {
  issues: AnalysedCriterion[];
  onTreatedIssueChange: (criterion: AnalysedCriterion) => any;
}

export default class IssuesToTreat extends React.Component<IssueToTreatProps> {
  render() {
    const issues = this.props.issues;
    const half = Math.ceil(issues.length * 0.5);
    return (
      <CategoryPanel label={i18n["Page.AssessmentResult.CriteriaGroupSelector.Title"]}>
        <div className="issues-to-treat">
          {issues.map((issue, index) => (
            <div
              key={issue.criterionId}
              className={this.getOrder(index, half) % 2 ? "odd" : "even"}
              style={{
                order: this.getOrder(index, half),
              }}
            >
              <input
                id={issue.criterionId}
                type="checkbox"
                checked={issue.isTreated}
                onChange={() => this.props.onTreatedIssueChange(issue)}
              />
              <label htmlFor={issue.criterionId}>{issue.criterionLabel}</label>
              <div className={`label secondary ${issue.severity.toLowerCase()}`}>
                <span>{issue.decisionLabel}</span>
              </div>
            </div>
          ))}
        </div>
      </CategoryPanel>
    );
  }

  private getOrder(index: number, half: number) {
    return 2 * (index % half) + (index < half ? 1 : 2);
  }
}
